import { TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { ReactActionDialogOptionsForConfirmationDialog, ReactConfirmationDialogBodyProps, ReactConfirmationDialogOptions } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { ModalInstance } from '~src/commonInfra/dialogs/ReactModalService';
import { HelpService } from '~src/commonInfra/services/HelpService';

import { externalUserTextLinkStyles } from './styles/DeleteGroupDialogStyles';

export const DeleteGroupConfirmationDialogBodyTestId = 'delete-group-confirmation-dialog-body';

export function openDeleteGroupConfirmationDialog<ActionParams, TResult>(
    options: ReactConfirmationDialogOptions<ActionParams, TResult>, containsExternalUserGroup: boolean
  ): ModalInstance<TResult> {

    function DeleteGroupConfirmationDialogWarningBody(props: ReactConfirmationDialogBodyProps): JSX.Element {
      return (
        <div data-tb-test-id={DeleteGroupConfirmationDialogBodyTestId}>
          <div style={{whiteSpace: 'pre-wrap'}}>
            {props.message}
          </div>
          {containsExternalUserGroup && <ExternalUserTextLink/>}
        </div>
      );
    }

    const actionDialogOptions: ReactActionDialogOptionsForConfirmationDialog<ActionParams, TResult> = {
      title: options.title,
      bodyComponent: DeleteGroupConfirmationDialogWarningBody,
      initialBodyProps: { message: options.message },
      initialDialogState: options.paramsForAction,
      actionName: options.actionName,
      action: (__, params) => options.action(params),
      dialogWidth: options.dialogWidth,
      dismissDialogOnActionFailed: true,
      isActionDelete: options.isActionDelete,
      centerActionButtons: options.centerActionButtons
    };

    return openReactActionDialog(actionDialogOptions);
  }

  export function ExternalUserTextLink(): JSX.Element {
    return <div style={externalUserTextLinkStyles}>
      <span>{Messages.groupDeleteEphemeralUserWarning()}</span>
      &nbsp;
      <TextLinkWidget
        testId={'external-user-learn-more'}
        target={'_blank'}
        href={HelpService.getHelpUrlByCategory('groups-ephemeral-users-delete')}
        kind={TextLinkKind.Standalone}>
        {Messages.learnMore()}
      </TextLinkWidget>
    </div>;
  }
